import { createTRPCContext } from "@trpc/tanstack-react-query"
import type { inferRouterOutputs, inferRouterInputs } from "@trpc/server"
import type { RentalsOwnerPortalRouter } from "@src/backend/src/rentals/functions/ownerPortal"

export const { TRPCProvider, useTRPC } = createTRPCContext<RentalsOwnerPortalRouter>()

export type RentalsOwnerPortalRouterOutputs =
  inferRouterOutputs<RentalsOwnerPortalRouter>
export type RentalsOwnerPortalRouterInputs =
  inferRouterInputs<RentalsOwnerPortalRouter>
